import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth';
import { Nav } from './components/Nav';
import { LoginPage } from './pages/Login';
import { HomePage } from './pages/Home';
import { LeasesPage } from './pages/Leases';
import { TenantsPage } from './pages/Tenants';
import { PropertiesPage } from './pages/Properties';
import { PremiseUsesPage } from './pages/PremiseUses';
import { AuditPage } from './pages/Audit';
import { ReconciliationsPage } from './pages/Reconciliations';
import { RentRollCheckPage } from './pages/RentRollCheck';
import { UsersPage } from './pages/Users';

const Guard = ({ children }: { children: JSX.Element }): JSX.Element => {
  const { user, loading } = useAuth();
  if (loading) return <div className="page">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const AdminGuard = ({ children }: { children: JSX.Element }): JSX.Element => {
  const { user } = useAuth();
  if (!user?.isAdmin) return <Navigate to="/" replace />;
  return children;
};

const Shell = () => (
  <div className="app-shell">
    <Nav />
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/leases" element={<LeasesPage />} />
      <Route path="/tenants" element={<TenantsPage />} />
      <Route path="/properties" element={<PropertiesPage />} />
      <Route path="/premise-uses" element={<PremiseUsesPage />} />
      <Route path="/audit" element={<AuditPage />} />
      <Route path="/reconciliation" element={<ReconciliationsPage />} />
      <Route path="/reconciliation/rent-roll-check" element={<RentRollCheckPage />} />
      <Route
        path="/users"
        element={
          <AdminGuard>
            <UsersPage />
          </AdminGuard>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </div>
);

export const App = () => (
  <AuthProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="*"
          element={
            <Guard>
              <Shell />
            </Guard>
          }
        />
      </Routes>
    </BrowserRouter>
  </AuthProvider>
);
